export default {
  data () {
    return {
      editable: false
    }
  },
  computed: {
    couldEditPolygon () {
      return this.insertPaths.length > 0 && !this.editing
    },
    editing () {
      return this.editable
    }
  },
  methods: {
    editPolygon () {
      this.editable = true
    },
    finishEditPolygon () {
      this.editable = false
    }
  }
}
